import { Navigate } from "./../../../../../router-utils"
import { useTripDetailsOutletContext } from "../_trip-details-context"

export default function TripDocumentsIndexPage() {
	const { trip } = useTripDetailsOutletContext()
	if (trip.converted_at) {
		// OTA: guests is the only document tab for converted trips
		return (
			<Navigate
				// to={"/trips/:tripId/docs/trip-voucher"}
				to={"/trips/:tripId/docs/guests"}
				replace
				params={{ tripId: trip.id.toString() }}
			/>
		)
	}
	return (
		<Navigate
			to={"/trips/:tripId/docs/trip-holding-email"}
			replace
			params={{ tripId: trip.id.toString() }}
		/>
	)
}
